import { getGetSubscriptionTemplateMockHandler } from "@vega-api/generated/subscription-templates-templates/subscription-templates-templates.msw";
import { type TemplateResponse } from "@vega-api/generated/types/templateResponse";
import { TextAnchorV2AnchorType } from "@vega-api/generated/types/textAnchorV2AnchorType";

/**
 * Custom mock handler for getting user profile that returns a user with ID that can be used for assignment.
 * This ensures the assignee dropdown and "Assign to Me" functionality work correctly.
 */
export const getSubscriptionByIdHandler = () => {
  // Create a consistent mock response with a user that can be assigned to cases
  const templateResponseAllOf: TemplateResponse = {
    data: {
      name: "New subscription template",
      fundId: "sdf",
      fundVehicleId: "sdf",
      questionnaireModel: {
        questionnaireTasks: [
          {
            id: "task-156399d2-e2a4-452e-9262-8bf5ec1ff8c5",
            name: "Task 1",
            type: "QUESTIONS",
            questions: [
              {
                id: "b10d3a1d-6530-4d12-a507-96fb30f4e398",
                type: "ADDRESS",
                title: "Question 1 adress",
                conditions: "",
                isRequired: true,
                anchorsV2: [
                  {
                    anchorType: TextAnchorV2AnchorType.TEXT,
                    name: "sdf4e398",
                    uniqueQuestionLabel: "sdf-d3a1",
                    path: "answer",
                  },
                ],
                uniqueQuestionLabel: "sdf-d3a1",
              },
              {
                id: "74b94955-e651-41bc-8090-2c0f3807ca72",
                type: "FORM",
                title: "Question 2 form",
                conditions: "",
                isRequired: true,
                anchorsV2: [
                  {
                    anchorType: TextAnchorV2AnchorType.TEXT,
                    name: "Ques2form7ca72",
                    uniqueQuestionLabel: "sdf-9495",
                    path: "answer",
                  },
                ],
                uniqueQuestionLabel: "sdf-9495",
              },
            ],
            description: "",
          },
        ],
      },
      tags: [],
      documentTemplateData: {
        fileId: "some-file-id",
        fileName: "Test DocX",
        contentType: "some-content",
        formFields: [],
        fileSize: 2048,
        dynamicSectionPlaceholders: [],
        signaturePlaceholders: [],
      },
      documentTemplateSections: [],
      id: "template-1758896813056-jlt2yhozw",
    },
  };

  return getGetSubscriptionTemplateMockHandler(templateResponseAllOf);
};
